import { useTranslation } from 'react-i18next';

import { RewardReferralRole } from '../../../models/RewardStore';
import { PngIcon } from '../../Molecules';
import { BasicPopupContainer } from '../Containers/BasicPopupContainer';

import styles from './CantBecomeRolePopup.module.css';

type CantBecomeRolePopup = {
  rewardReferralRole: RewardReferralRole;
  onPrimary: () => void;
};
export const CantBecomeRolePopup = (props: CantBecomeRolePopup) => {
  const { rewardReferralRole, onPrimary } = props;
  const { t } = useTranslation();
  return (
    <BasicPopupContainer
      onPrimaryButtonClick={onPrimary}
      primaryButtonLabel={t('OK')}
    >
      <div className={styles.container}>
        <div className={styles.iconContainer}>
          {<PngIcon name="Notice" width={80} height={80} />}
        </div>
        <div className={styles.titleContainer}>
          <p className={styles.title} />
        </div>
        <div className={styles.contentContainer}>
          <div className={styles.text}>
            {t(
              `You are being referred or have already referred users, so you are not eligible to become a JOYAJOY ${
                rewardReferralRole === RewardReferralRole.Distributor
                  ? 'Distributor'
                  : 'Partner'
              }.`,
            )}
          </div>
          <div className={styles.text}>
            {t('You may create a new account.')}
          </div>
        </div>
      </div>
    </BasicPopupContainer>
  );
};
